import React, {FC} from 'react';

type Props = {
  alertType: number | undefined;
};

export const AlertTypeIndicator: FC<Props> = ({alertType}) => (
  <div
    className={`h-16 w-2 rounded-30 mr-2
        ${alertType === 0 && 'bg-trak-green'}
        ${alertType === 1 && 'bg-trak-yellow'}
        ${alertType === 2 && 'bg-trak-red'}
    `}
  />
);
